module.exports = __webpack_public_path__ + "img/box5-07.af91cb7f.png";